import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { blenderCss } from '@clds/blender';
import { createUseFoundationHook } from '@clds/design-system-foundations';
import { lightTheme } from '@clds/themes';
import { iconNextSizeVariant } from './theme.js';
const palette = lightTheme.palette;
const getColor = (colorName) => palette[colorName] ?? colorName;
const StyledSvg = styled.svg(({ size, color }) => css `
    width: ${iconNextSizeVariant(size).width};
    height: ${iconNextSizeVariant(size).width};
    fill: ${color === undefined
    ? css `var(${blenderCss.variables.foregroundColor}, currentColor)`
    : getColor(color)};
  `);
const { useFoundation } = createUseFoundationHook(({ size }) => ({ size: size === 'xxs' ? 'xs' : size }), (props) => props, { size: 'md' });
export const GenericIcon = ({ size, color, path, ...rest }) => {
    const foundation = useFoundation({ size });
    return (_jsx(StyledSvg, { "data-test": "icon", ...foundation.componentProps, color: color, viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid", ...rest, children: _jsx("path", { d: path }) }));
};
//# sourceMappingURL=GenericIcon.js.map